import React, { useState } from "react";
import { RiCupFill } from "react-icons/ri";
import { PiLightbulbFill, PiSlidersHorizontalFill } from "react-icons/pi";
import { MdKeyboardArrowDown } from "react-icons/md";
import Links from "../sub-components/Links";

const { PUBLIC_URL } = process.env;

const Feature3 = () => {

  const dashboard_Video = process.env.REACT_APP_DASHBOARD_VIDEO;

  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div>
      <section className="section main-banner" id="f3top">
        <video autoPlay muted loop id="bg-video">
          <source
            src={dashboard_Video}
            type="video/mp4"
          />
        </video>

        <div className="video-overlay header-text">
          <div className="caption">
            <h4 style={{ color: "#f5a425" }}>
              AI-powered question
              <br />
              generator
            </h4>
            <h6>
              Create quizzes, tests, and exams 10 times faster.
              <br /> Experience the AI-driven revolution in assessment creation
              today.
            </h6>

            <div className="main-button">
              <div className="scroll-to-section">
                <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
              </div>
            </div>
            <br />
            {/* <div>
                <a style={{ fontSize: "16px", color: "white" }}>Learn more</a>
                <br />
                <GoArrowDown style={{ color: "white" }} />
              </div> */}
          </div>
        </div>
      </section>

      <section className="dark-bg">
        <div className="container-fluid dark-bg-sec">
          <div className="row f3sec1">
            <div className="col-lg-12 f3sec1head ">
              <h4>Generate questions from text, files and more</h4>
              <h2>Why generate questions with AI?</h2>
            </div>

            <div className="col-lg-4 f3sec1content">
              <div>
                <PiLightbulbFill className="f3sec1contIcon" />
              </div>

              <h3>Get inspired</h3>
              <p>
                You don't have to start from scratch! Use NexTestify platform as
                your co-pilot and get started in seconds with AI-generated
                question ideas.
              </p>
            </div>

            <div className="col-lg-4 f3sec1content">
              <div>
                <RiCupFill className="f3sec1contIcon" />
              </div>
              <h3>Speed up work</h3>
              <p>
                No time? No problem! Simply tell NexTestify AI what kind of
                questions you need. Upload your source of knowledge and let our
                platform work its magic. It only takes a minute.
              </p>
            </div>
            <div className="col-lg-4 f3sec1content">
              <div>
                <PiSlidersHorizontalFill className="f3sec1contIcon" />{" "}
              </div>

              <h3>Create variants of questions</h3>
              <p>
                Our AI can generate different versions of questions to the same
                content. To use this feature, simply reupload your file and let
                our algorithms try a new approach.
              </p>
            </div>
          </div>
        </div>
        {/* <div className="container text-center">
            <div className="col-lg-12">
              <h5>
                Create questions 10x faster{" "}
                <span className="button">
                <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </span>
              </h5>
            </div>
          </div> */}
      </section>

      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="row f3sec2">
            <div className="col-lg-6 f3sec2content">
              <h3>Question generator from text and files</h3>
              <p>
                NexTestify AI can generate questions and answers based on your
                content, such as product or service information, technical
                specifications, and more. To get started, simply upload the
                relevant files or copy and paste the content directly. Providing
                more information as input will result in higher quality
                questions. Once generated, all questions will be available for
                your review.
              </p>
            </div>

            <div className="col-md-12 col-lg-6 f3sec2img">
              <article className="video-item ">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/ai-tp1.webp`}
                    alt=""
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_l_r.svg`}
                    alt=""
                    className="green_l_r"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_r_l.svg`}
                    alt=""
                    className="green_r_l"
                  />
                </figure>
              </article>
            </div>
          </div>
        </div>
      </section>

      <section className="dark-bg2">
        <div className="container-fluid dark-bg2-sec">
          <div className="row f3sec3">
            <div className="col-md-12 col-lg-6 f3sec3img">
              <article className="video-item ">
                <figure>
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/ai-tp2.webp`}
                    alt=""
                  />
                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_top.svg`}
                    alt=""
                    className="green_curve_top"
                  />

                  <img
                    src={`${PUBLIC_URL}/assets/testPortal/green_curve_bottom.svg`}
                    alt=""
                    className="green_curve_bottom"
                  />
                </figure>
              </article>
            </div>

            <div className="col-lg-6 f3sec3content">
              <h3>Question generator on selected topics</h3>
              <p>
                Perfect solution for hiring managers who need to assess
                candidates but want to speed-up the test-making processes and
                get inspired. Simply enter the topic to which you want your
                AI-generated content to relate and let NexTestify deliver
                question ideas. That's an excellent starting point. You can
                always modify your questions, add more, and enrich them with
                media.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="light-bg">
        <div className="container-fluid light-bg-sec">
          <div className="row f3sec4">
            <div className="col-lg-6 f3sec4head">
              <h4>
                How to use AI-generated <br /> question?
              </h4>
              <p>
                After the AI generates questions, you have the
                <br /> freedom to decide what to do next.
              </p>
              <div className="main-button">
                <div className="scroll-to-section">
                  <a href={`${PUBLIC_URL}/#section3`}>Sign up - it's free</a>
                </div>
              </div>
            </div>

            <div className="col-lg-6 f3sec4content">
              <ul>
                <li>
                  <h4>Create online tests, quizzes, or exams</h4>
                  <p>
                    Share AI-generated questions with your respondents in just a
                    few clicks. Use questions directly in NexTestify.
                  </p>
                </li>
                <li>
                  <h4>Download and print</h4>
                  <p>
                    You can download test sheets with AI-generated questions any
                    time.
                  </p>
                </li>
                <li>
                  <h4>API to generate questions</h4>
                  <p>
                    NexTestify offers API, allowing your software to leverage
                    the capabilities of the market's best question generator.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="img-bg">
        <div className="container-fluid img-bg-sec">
          <div className="container f3sec5">
            <h3>What is AI question generator?</h3>
            <p>
              An AI question generator harnesses the power of artificial
              intelligence to simplify the process of creating questions from
              text. This innovative tool applies machine learning to interpret
              your provided text, subsequently crafting relevant questions. It
              can also generate questions on selected topics from the sources
              generally available in the internet.
            </p>
            <p>
              Imagine possessing a hefty document and the task of constructing a
              quiz or study guide. Our tool relieves this burden by using AI to
              develop insightful questions directly from your text. This
              automated process saves time, enhances efficiency, and ensures
              reliable outcomes.
            </p>
            <p>
              This tool is really handy for trainers, customer service teams,
              and sales departments.
            </p>
            <p>
              The underlying technology involves natural language processing and
              a transformer-based model, which can understand context,
              semantics, and even nuances in language.
            </p>
            <p>
              Generating questions from text using AI is more than just a
              technological advancement - it represents a transformation in our
              interaction with information. With this tool, experience the
              numerous benefits of automated question creation and observe a
              significant boost in your efficiency.
            </p>
          </div>
        </div>
      </section>

      <section className="dark-bg2">
        <div className="container-fluid dark-bg2-sec">
          <div className="container f3sec6">
            <h3>FAQ</h3>

            <div className="f3sec6content">
              <ul>
                {activeIndex === 0 ? (
                  <div className="panel2">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(0)}
                      >
                        Is there a character limit for generating questions from
                        text? <MdKeyboardArrowDown />
                      </button>
                    </li>
                    <p>
                      No, there's no character limit. Feel free to upload
                      content of any length, and NexTestify's AI will generate
                      questions from it.
                    </p>
                  </div>
                ) : (
                  <li className="accordion2">
                    <button
                      className="list_button text-white"
                      onClick={() => handleAccordion(0)}
                      style={{ cursor: "pointer" }}
                    >
                      Is there a character limit for generating questions from
                      text? <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 1 ? (
                  <div className="panel2">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(1)}
                      >
                        What languages do you support <MdKeyboardArrowDown />
                      </button>
                    </li>
                    <p>
                      Our AI-based question generator supports all languages.
                    </p>
                  </div>
                ) : (
                  <li className="accordion2">
                    <button
                      className="list_button text-white"
                      onClick={() => handleAccordion(1)}
                      style={{ cursor: "pointer" }}
                    >
                      What languages do you support <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}

                {activeIndex === 2 ? (
                  <div className="panel2">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(2)}
                      >
                        Do you respect privacy when processing data with AI{" "}
                        <MdKeyboardArrowDown />
                      </button>
                    </li>
                    <p>
                      Absolutely. Rest assured, the materials you upload to
                      NexTestify remain exclusively yours. We value and respect
                      your privacy.
                    </p>
                  </div>
                ) : (
                  <li className="accordion2">
                    <button
                      className="list_button text-white"
                      onClick={() => handleAccordion(2)}
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      Do you respect privacy when processing data with AI{" "}
                      <MdKeyboardArrowDown />
                    </button>{" "}
                  </li>
                )}

                {activeIndex === 3 ? (
                  <div className="panel2">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(3)}
                      >
                        How much does it cost ? <MdKeyboardArrowDown />
                      </button>{" "}
                    </li>
                    <p>
                      Generating questions using our AI is included in all
                      business plans at no additional cost.
                    </p>
                  </div>
                ) : (
                  <li className="accordion2">
                    <button
                      className="list_button text-white"
                      onClick={() => handleAccordion(3)}
                      style={{ cursor: "pointer" }}
                    >
                      How much does it cost ? <MdKeyboardArrowDown />
                    </button>{" "}
                  </li>
                )}

                {activeIndex === 4 ? (
                  <div className="panel2">
                    <li>
                      <button
                        className="list_button"
                        style={{
                          color: "#f5a425",
                          cursor: "pointer",
                          fontWeight: "500",
                        }}
                        onClick={() => handleAccordion(4)}
                      >
                        What types of questions are available{" "}
                        <MdKeyboardArrowDown />
                      </button>
                    </li>
                    <p>
                      NexTestify is equipped with an advanced multiple-choice
                      question (MCQ) generator. But it's not just about MCQs.
                      You also have the flexibility to create short answer and
                      essay questions.
                    </p>
                  </div>
                ) : (
                  <li className="accordion2">
                    <button
                      className="list_button text-white"
                      onClick={() => handleAccordion(4)}
                      style={{ cursor: "pointer" }}
                    >
                      What types of questions are available{" "}
                      <MdKeyboardArrowDown />
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </section>
      <Links />
    </div>
  );
};

export default Feature3;
